// AccuReference form state and constants.
// Test data is now fetched from FHIR ActivityDefinition resources via useTestCatalog hook.
// Panel components and specimen legend remain hardcoded as display metadata.

export const ACCU_REFERENCE_QUESTIONNAIRE_ID = 'accu-reference-general-test-v2.1'

// ---------------------------------------------------------------------------
// Panel component compositions (display metadata — shows what's in each panel)
// ---------------------------------------------------------------------------

export const ACCU_PANEL_COMPONENTS: Record<string, { code: string; name: string }[]> = {
  '335V': [
    { code: '995', name: 'Vitamin D-25 Hydroxy' },
    { code: '125', name: 'Magnesium' },
    { code: '39', name: 'Vitamin B12 and Folate' },
    { code: '115', name: 'Ferritin' },
    { code: 'IRIB', name: 'Iron + TIBC + UIBC + SAT' },
    { code: '20', name: 'CBC with Automated Diff' },
    { code: '119', name: 'Hemoglobin A1C' },
    { code: '030', name: 'Urinalysis' },
    { code: '146N', name: 'TSH 3rd Generation' },
    { code: '38', name: 'Lipid Panel' },
    { code: '12', name: 'Comprehensive Metabolic' },
  ],
  '336V': [
    { code: '995', name: 'Vitamin D-25 Hydroxy' },
    { code: '125', name: 'Magnesium' },
    { code: '39', name: 'Vitamin B12 and Folate' },
    { code: '115', name: 'Ferritin' },
    { code: 'IRIB', name: 'Iron + TIBC + UIBC + SAT' },
    { code: '20', name: 'CBC with Automated Diff' },
    { code: '119', name: 'Hemoglobin A1C' },
    { code: '030', name: 'Urinalysis' },
    { code: '146N', name: 'TSH 3rd Generation' },
    { code: '38', name: 'Lipid Panel' },
    { code: '12', name: 'Comprehensive Metabolic' },
    { code: '196', name: 'PSA' },
    { code: '187', name: 'Testosterone Total' },
  ],
  '337V': [
    { code: 'S236', name: 'Testosterone Free & Total' },
    { code: '101', name: 'Albumin' },
    { code: 'A134', name: 'Progesterone' },
    { code: '4462', name: 'Estrogens, Total' },
    { code: '139', name: 'FSH' },
    { code: '140', name: 'LH' },
  ],
  '338V': [
    { code: '1076', name: 'DS DNA' },
    { code: 'C142', name: 'Jo-1 IgG' },
    { code: '110', name: 'CPK (Creatine Kinase)' },
    { code: '137', name: 'Uric Acid' },
    { code: 'B061', name: 'Sjogren SS-A SS-B IgG Ab' },
    { code: '1536', name: 'CRP Quantitative' },
    { code: '5078', name: 'Thyroid Peroxidase (TPO) Antibodies' },
    { code: '304', name: 'Rheumatoid Factor' },
    { code: '246', name: 'Sedimentation Rate' },
    { code: '4578', name: 'ANCA (MPO/PR3) Profile' },
    { code: 'SCS', name: 'SCL-70 IgG' },
  ],
  '339V': [
    { code: 'SRZN', name: 'Zinc, ICP-MS' },
    { code: '1536', name: 'CRP Quantitative' },
    { code: '995', name: 'Vitamin D-25 Hydroxy' },
    { code: '754', name: 'DHEA-Sulfate' },
    { code: '5078', name: 'Thyroid Peroxidase (TPO) Antibodies' },
    { code: '39', name: 'Vitamin B12 and Folate' },
    { code: '181', name: 'Prolactin' },
    { code: '304', name: 'Rheumatoid Factor' },
    { code: '4562', name: 'ANA, reflex to IFA ENAs' },
  ],
  '340V': [
    { code: '12', name: 'Comprehensive Metabolic' },
    { code: 'CALP', name: 'Calpropectin' },
    { code: '1536', name: 'CRP Quantitative' },
    { code: '162', name: 'Vitamin B12' },
    { code: '115', name: 'Ferritin' },
    { code: 'IRIB', name: 'Iron + TIBC + UIBC + SAT' },
    { code: '20', name: 'CBC with Automated Diff' },
    { code: '146N', name: 'TSH 3rd Generation' },
    { code: '4562', name: 'ANA, reflex to IFA ENAs' },
    { code: '111', name: 'Tissue Transglut (tTG) IgA' },
    { code: '1057', name: 'Gliadin IgG' },
    { code: '995', name: 'Vitamin D-25 Hydroxy' },
    { code: 'OVP1', name: 'Ova and Parasites' },
    { code: 'Z31', name: 'Giardia, EIA' },
    { code: 'STCU', name: 'Stool Culture' },
    { code: 'Z24', name: 'WBC, Fecal' },
    { code: '246', name: 'Sedimentation Rate' },
    { code: 'GIB', name: 'GI Bacterial Panel' },
    { code: 'GIV', name: 'GI Viral Panel' },
    { code: 'GIPP', name: 'GI Parasite Panel' },
    { code: 'CDP', name: 'Clostridium Difficile' },
  ],
  '341V': [
    { code: '995', name: 'Vitamin D-25 Hydroxy' },
    { code: 'S236', name: 'Testosterone Free & Total' },
    { code: 'A134', name: 'Progesterone' },
    { code: '115', name: 'Ferritin' },
    { code: '20', name: 'CBC with Automated Diff' },
    { code: '119', name: 'Hemoglobin A1C' },
    { code: '030', name: 'Urinalysis' },
    { code: '146N', name: 'TSH 3rd Generation' },
    { code: '252', name: 'Free T4' },
    { code: '4515', name: 'Antimullerian Hormone' },
    { code: '139', name: 'FSH' },
    { code: '140', name: 'LH' },
    { code: '38', name: 'Lipid Panel' },
    { code: '12', name: 'Comprehensive Metabolic' },
    { code: 'A232', name: 'Hepatitis A Antibody, Total' },
    { code: '0236', name: 'Anti-HAV IgM' },
    { code: '318', name: 'Anti-HBc IgM' },
    { code: '320', name: 'Hepatitis B Surface Antibody' },
    { code: '321', name: 'Hepatitis B Core Antibody' },
    { code: 'A701', name: 'Hepatitis C Antibody' },
    { code: '319', name: 'HBsAg' },
  ],
}

// ---------------------------------------------------------------------------
// Specimen type legend (display helper)
// ---------------------------------------------------------------------------

export const SPECIMEN_TYPE_LEGEND: Record<string, string> = {
  SS: 'Serum Separator (Gold/Red)',
  LV: 'Lavender (EDTA)',
  GY: 'Gray',
  GR: 'Green (Lithium Heparin)',
  GREEN: 'Green (Lithium Heparin)',
  BL: 'Blue (Citrate)',
  RE: 'Red',
  UA: 'Urine',
  UC: 'Urine Cup',
  'Sw/Sal': 'Swab / Saliva',
  eSwab: 'eSwab',
  STOOL: 'Stool Container',
  FL: 'Fluid',
  SW: 'Swab',
  ST: 'Stool',
  TP: 'ThinPrep',
  AP: 'Anal/Penile',
  URINE: 'Urine',
  KIT: 'Kit',
}

// ---------------------------------------------------------------------------
// Form State
// ---------------------------------------------------------------------------

export interface AccuReferenceFormState {
  // Patient Information
  firstName: string
  middleName: string
  lastName: string
  sexAtBirth: string
  dateOfBirth: string
  mobilePhone: string
  email: string
  address: string
  apt: string
  city: string
  state: string
  zip: string

  // Physician / Provider
  physicianNameAndAddress: string

  // Insurance Information
  billingSelection: string
  insuranceName: string
  memberId: string
  primaryInsurance: string
  primaryGroup: string
  policyholderName: string
  relationship: string

  // Specimen Collection
  specimenCollectionDate: string
  specimenCollectionTime: string
  specimenCollectionAmPm: string

  // Flags
  isStat: boolean
  isFasting: boolean

  // ICD-10 Diagnoses (free text)
  diagnosisText: string

  // Test Selection — single unified array of test codes
  selectedTests: string[]

  // Microbiology
  microbiologySource: string

  // Gynecology
  gynBiopsySites: string[]
  gynLmp: string
  gynSource: string

  // Signature
  signatureDate: string
  signatureDataUrl: string

  // Dispatch
  dispatchPhlebotomist: boolean

  // Provider (auto-populated, hidden)
  organizationName: string
  orgPhone: string
  orgFax: string
  orgAddress: string
  orgCity: string
  orgState: string
  orgZip: string
  orderingProviderName: string
  orderingProviderNpi: string
}

export function createInitialAccuReferenceFormState(): AccuReferenceFormState {
  return {
    firstName: '',
    middleName: '',
    lastName: '',
    sexAtBirth: '',
    dateOfBirth: '',
    mobilePhone: '',
    email: '',
    address: '',
    apt: '',
    city: '',
    state: '',
    zip: '',

    physicianNameAndAddress: '',

    billingSelection: 'insurance',
    insuranceName: '',
    memberId: '',
    primaryInsurance: '',
    primaryGroup: '',
    policyholderName: '',
    relationship: 'self',

    specimenCollectionDate: '',
    specimenCollectionTime: '',
    specimenCollectionAmPm: 'AM',

    isStat: false,
    isFasting: false,

    diagnosisText: '',

    selectedTests: [],

    microbiologySource: '',

    gynBiopsySites: [],
    gynLmp: '',
    gynSource: '',

    signatureDate: '',
    signatureDataUrl: '',

    dispatchPhlebotomist: false,

    organizationName: '',
    orgPhone: '',
    orgFax: '',
    orgAddress: '',
    orgCity: '',
    orgState: '',
    orgZip: '',
    orderingProviderName: '',
    orderingProviderNpi: '',
  }
}
